/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityaspectarchetype2Inputs */



/**
* | output |
* | --- |
* | "Archetype" |
*
* @param {Personalityaspectarchetype2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityaspectarchetype2 = /** @type {((inputs?: Personalityaspectarchetype2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityaspectarchetype2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Archetype")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arquetipo")
	return /** @type {LocalizedString} */ ("Архетип")
});
export { personalityaspectarchetype2 as "personalityAspectArchetype" }